import en from '@/lang/en'
import fr from '@/lang/fr'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'

const DEFAULT_H5_LANGUAGE = 'en'
const H5_MESSAGES = { en, fr }

function currentStorageLanguage() {
  try {
    return safeGetStorageItem(safeLocalStorage(), 'defaultLanguage', DEFAULT_H5_LANGUAGE)
  } catch (e) {
    return DEFAULT_H5_LANGUAGE
  }
}

export function h5Language() {
  const language = currentStorageLanguage()
  return H5_MESSAGES[language] ? language : DEFAULT_H5_LANGUAGE
}

export function h5Text(key, fallback = '') {
  const language = h5Language()
  const currentMessages = H5_MESSAGES[language] || H5_MESSAGES[DEFAULT_H5_LANGUAGE]
  return currentMessages[key] || H5_MESSAGES[DEFAULT_H5_LANGUAGE][key] || fallback || ''
}
